import { Link, LinkProps } from "@amzn/awsui-components-react";
import * as React from "react";
import { QueryResultItem } from "@aws-sdk/client-kendra";
import { getInstanceIdFromResult } from "../../../utils/search-utils";
import { useCrossInstanceSearch } from "../../../hooks/use-cross-instance-search";
import { CrossInstanceRedirectModal } from "./CrossInstanceRedirectModal";

interface CrossInstanceLinkProps extends Omit<LinkProps, "onClick" | "href"> {
    resultItem?: QueryResultItem;
    targetInstanceId?: string;
    currentInstanceId: string;
    targetUrl: string;
    onClickFeedback?: () => void;
}

export const CrossInstanceLink: React.FC<CrossInstanceLinkProps> = ({
    resultItem,
    targetInstanceId,
    currentInstanceId,
    targetUrl,
    children,
    onClickFeedback,
    ...linkProps
}) => {
    const [showRedirectModal, setShowRedirectModal] = React.useState(false);
    const isCrossInstanceEnabled = useCrossInstanceSearch();

    const resultInstanceId = targetInstanceId || (resultItem ? getInstanceIdFromResult(resultItem) : null);
    const isCrossInstance = isCrossInstanceEnabled && resultInstanceId && resultInstanceId !== currentInstanceId;

    const handleLinkClick = (e: React.MouseEvent) => {
        if (onClickFeedback) {
            onClickFeedback();
        }

        if (isCrossInstance) {
            e.preventDefault();
            setShowRedirectModal(true);
        }
    };

    const handleModalRedirect = () => {
        setShowRedirectModal(false);
        window.open(targetUrl, "_blank");
    };

    const handleModalCancel = () => {
        setShowRedirectModal(false);
    };

    return (
        <>
            <Link
                {...linkProps}
                href={isCrossInstance ? undefined : targetUrl}
                onClick={handleLinkClick}
            >
                {children}
            </Link>
            {isCrossInstance && (
                <CrossInstanceRedirectModal
                    visible={showRedirectModal}
                    currentInstanceId={currentInstanceId}
                    targetInstanceId={resultInstanceId}
                    onRedirect={handleModalRedirect}
                    onCancel={handleModalCancel}
                />
            )}
        </>
    );
};
